"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectUsers = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectUsers, _Component);

  function ProjectUsers() {
    (0, _classCallCheck3.default)(this, ProjectUsers);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectUsers.__proto__ || (0, _getPrototypeOf2.default)(ProjectUsers)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectUsers, [{
    key: "render",
    value: function render() {
      var users = this.props.users;

      return this.renderMemberList();
    }
  }, {
    key: "renderEmptyMessage",
    value: function renderEmptyMessage() {
      return _react2.default.createElement(
        "div",
        { className: "voucher-order-cart" },
        _react2.default.createElement(
          "p",
          null,
          "Lista on tyhj\xE4."
        )
      );
    }
  }, {
    key: "renderMemberList",
    value: function renderMemberList() {
      return _react2.default.createElement(
        "ul",
        null,
        this.renderItems()
      );
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var users = this.props.users;


      if (!users || !users.length) {
        return null;
      }
      return users.map(function (item, index) {

        return _react2.default.createElement(
          "li",
          { key: index },
          item.email,
          " "
        );
      });
    }
  }]);
  return ProjectUsers;
}(_react.Component), _class.propTypes = {
  users: _react.PropTypes.array
}, _temp);
exports.default = ProjectUsers;

ProjectUsers;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/ProjectUsers.js
 ** module id = 1177
 ** module chunks = 0
 **/